import React from 'react'
import PropTypes from 'prop-types'

const MultiSearchNoResults = ({ canSelectSearchTerm, handleClick, label, addStyles, emptyStyles, noResultsText }) => {
  let newProps = { className: emptyStyles, children: noResultsText }
  if (canSelectSearchTerm) {
    newProps = { onClick: handleClick, className: addStyles, children: `Add "${label}"` }
  }

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <li {...newProps} />
}

export default MultiSearchNoResults

MultiSearchNoResults.propTypes = {
  canSelectSearchTerm: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  noResultsText: PropTypes.string.isRequired,
  addStyles: PropTypes.string.isRequired,
  emptyStyles: PropTypes.string.isRequired,
}
